import NormalBtn from '../StockItems/NormalBtn';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import * as ServerComms from '../utilities/ServerComms';
import * as SharedAcross from '../utilities/SharedAcross';
import * as FormulaFunctions from '../utilities/FormulaFunctions';
import React, {useState, useEffect}  from 'react';
import {fillUpEntityRecursively} from '../utilities/FillUp';
import * as StyleFunctions from '../utilities/StyleFunctions';
import ClientDatabase from '../ClientDatabase';
import { saveAs } from 'file-saver';

function App(props) {

  var setSelectedStep = props.setSelectedStep;
  var programSetID = props.programSetID;
  var sessionID = props.sessionID;
  var userID = props.userID;
  var signKey = props.signKey;
  var nosCredits = props.nosCredits;
  var setNosCredits = props.setNosCredits;
  var relevantLaunchInfo = props.relevantLaunchInfo;
  var history = props.history;
  var setHistory = props.setHistory;
  var height = props.height
  var currentList = props.currentList
  var clickBack = props.clickBack;
  var addToExtraScreen = props.addToExtraScreen;

  function setLaunchInfo(response){
    relevantLaunchInfo.v[3] = response.v[1].v[0];
    relevantLaunchInfo.v[4] = response.v[1].v[1];
    relevantLaunchInfo.v[5] = response.v[1].v[2];
    relevantLaunchInfo.v[6] = response.v[1].v[3];
    relevantLaunchInfo.v[8] = response.v[1].v[4];
    relevantLaunchInfo.v[9] = response.v[1].v[5];
    setHistory([...history]);
    setNosCredits(response.v[0].v);

    var msg = fillUpEntityRecursively(response.v[2]);
    setLaunchedCode(msg);
  }

  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [statsInfo, setStatsInfo] = useState(false);
  const [launchedCode, setLaunchedCode] = useState(false);

  function clickSelect(path){
    return function(e){
      setSelectedStep(path);
    }
  }

  function failFunction(e){
    setIsDoingSomething(false);
  }


  function getStatistics(){
    var passObject = {
        u:'viewStatistics',
        programSetID,
        sessionID,
        signKey,
        userID,
      };
    function postFunction(value){
      setStatsInfo(value.v[0]);
      var msg = fillUpEntityRecursively(value.v[1]);
      setLaunchedCode(msg);
    }
    ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
  }

  useEffect(()=>{
    getStatistics();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var sqlDeployUntil = relevantLaunchInfo.v[4];
  var sqlUpdate = relevantLaunchInfo.v[3];
  var currentUrl = relevantLaunchInfo.v[5].v;
  var firstDeployed = relevantLaunchInfo.v[6];
  var addTimePart = <NormalBtn onClick={clickSelect(['de', 'addTime'])} title='Add Time'/>
  var header;

  var isAlive = FormulaFunctions.isDeploymentAlive(sqlDeployUntil);
  var dateExpiryString = FormulaFunctions.getDateTimeFromSql(sqlDeployUntil);
  var dateUpdatedString = FormulaFunctions.getDateTimeFromSql(sqlUpdate);

  function clickUrl(){
    if (isAlive){
      window.open('https://www.cues.sg/dapps/'+currentUrl);
    }else{
      window.alert('Launch expired. Please add credits to launch');
    }
  }

  function clickUpdate(){
    setIsDoingSomething({t:'updatingDapp'});
    var passObject = {
        u:'updateDapp',
        currentList,
        programSetID,
        sessionID,
        signKey,
        userID,
      };
    function postFunction(value){
      if (value.t === 'tuple'){
        setLaunchInfo(value);
        setIsDoingSomething(false);
        window.alert('Updated!');
      }else if (value.t === 'atom'){
        if (value.v === 'alreadyUsed'){

        }
      }
    }
    ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
  }

  function clickChangeUrl(){
    var p = window.prompt('Please enter the new url', currentUrl);
    if (p === undefined || p === null){
      return        
    }
    p = p.trim();
    if (!p){
      window.alert('Empty url not allowed');
      return;
    }
    var xx = SharedAcross.isAlphaNumeric(p);
    if (xx){

      setIsDoingSomething({t:'changingUrl'});
      var passObject = {
          u:'changeUrl',
          programSetID,
          sessionID,
          signKey,
          userID,
          url:p,
        };
      function postFunction(value){
        setIsDoingSomething(false);
        if (value.t === 'atom'){
          window.alert('Sorry, this url name has been taken. Please use another name.');
        }else{
          setLaunchInfo(value);
          window.alert('Updated!');

        }
      }
      ServerComms.fetchSomething(passObject, postFunction, failFunction, []);

    }else{
      window.alert('Only numbers underscores and letters allowed');
      return;
    }
  }
  
  var infoSet = [{t:'Url', i:'https://www.cues.sg/dapps/'+currentUrl, f:clickUrl}];

  var until = FormulaFunctions.currentDateFromSql(sqlDeployUntil);
  var from = FormulaFunctions.currentDateFromSql(firstDeployed);
  var totalDeployTime = until.getTime() - from.getTime();
  if (totalDeployTime > 1000 * 3600 * 24 * 60){
    infoSet.push({t:'Change Url', i:'Click to Change', f:clickChangeUrl});
  }else{
    infoSet.push({t:'Change Url', i:'URLs can only be changed for packages with more than 60 days' });
  }



  var localHostTd;
  if (relevantLaunchInfo.v[9].v){


    function downloadFile(e){
      var JSZip = require('jszip');
      var zip = new JSZip();
      var fileName = 'index.html';
      var origUrk = window.prompt('What is the Url of your site?', 'https://xxx');
      if (origUrk){
        var pageContentsA = '<html><head><title>'+relevantLaunchInfo.v[1].v+'</title><meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"></head><body><div id = "root"></div><script type="text/javascript">var url = parent.document.URL; var prefix = "'+origUrk+'"; if (url.startsWith(prefix)) {url = url.slice(prefix.length);} document.write(\'<iframe style=\"position:fixed; top:0px; left:0px; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;\" src=\"https://www.cues.sg/dapps/'+relevantLaunchInfo.v[5].v+'\' + url + \'\"  ></iframe>\');</script></body></html>';
        zip.file(fileName, pageContentsA);

        zip.generateAsync({type:"blob"})
        .then(function(content) {
            // see FileSaver.js
            saveAs(content, 'index.zip');
        });

      }

    }

    localHostTd = <td><NormalBtn key='0' onClick={downloadFile} title='Click to download file'/><br/>On Bluehost, go to your cPanel, then click on File Manager. Upload the file to the public_html folder.<br/></td>
//
  }else if (nosCredits < 10){

    function addCredFunction(e){
      addToExtraScreen({t:'credits',v:10});
    }
    localHostTd = <td>10 credits required<br/><NormalBtn key='0' onClick={addCredFunction} title='Click to Add Credits'/></td>
//    
  }else{

    function clickLink(e){
      var passObject = {
          u:'linkDomain',
          programSetID,
          sessionID,
          signKey,
          userID,
        };
      function postFunction(value){
        // setIsDoingSomething(false);
        setLaunchInfo(value);
      }
      ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
    }

    localHostTd = <td><NormalBtn key='0' onClick={clickLink} title='Click to Get Code'/></td>
//
    // infoSet.push({t:'', i:'Click to Download (10 credits)', f:clickLink})
  }

  var ownDomainRow = [<tr key='time'><td ><b>Get code for your own domain (e.g. Bluehost) so that users to your own domain will be redirected to the cues-hosted site</b></td>{localHostTd}</tr>]
//
  if (isDoingSomething && isDoingSomething.t === 'updatingDapp'){
    infoSet.push({t:'Date of latest update',i:dateUpdatedString + ' [Updating...]'});
  }

  if (relevantLaunchInfo.v[8].v){
    infoSet.push({t:'Allow Cues.sg to help publicise your dApp on our publicity channels', i:'Agreed'})
  }else{
    function clickConsent(e){
      var passObject = {
          u:'consentShare',
          programSetID,
          sessionID,
          signKey,
          userID,
        };
      function postFunction(value){
        // setIsDoingSomething(false);
        setLaunchInfo(value);
      }
      ServerComms.fetchSomething(passObject, postFunction, failFunction, []);

    }
    infoSet.push({t:'Allow Cues.sg to help publicise your dApp on our publicity channels', i:'Click to Agree', f:clickConsent})
  }


  // if (infoSet.length === 1){
  //   infoSet.push({t:'Date of latest update',f:clickUpdate,i:dateUpdatedString + ' [Click to update]'});
  // }


  function clickAnInfo(f){
    return function(e){
      if (f){
        f();
      }
    }
  }
  var infoRows = infoSet.map((anInfo, index)=>{
    var s = {};
    if (anInfo.f){
      s.textDecoration = 'underline';
      s.cursor = 'pointer';
    }
    return <tr key={index} onClick={clickAnInfo(anInfo.f)}><td><b>{anInfo.t}</b></td><td style={s}>{anInfo.i}</td></tr>
  })
//

//
  var subtitle;
  var subtitleBreak;
//
  if (isAlive){
    header = 'dApp Launched!';

    var timeStamp = FormulaFunctions.currentDateFromSql(sqlDeployUntil);
    var timeStampInt = timeStamp.getTime();
    var currentDate = new Date();
    var currentDateInt = currentDate.getTime();
    
    var diff = Math.floor((timeStampInt - currentDateInt) / 1000);
    if (diff > 60 * 60 * 24 * 330){
      addTimePart = null;
    }else{        
      subtitle = 'Page expires in ' + StyleFunctions.getTimeDelay(diff)
      subtitleBreak = <br/>
    }
//
  }else{
    header = 'Page Expired';
  }

  var first = [<tr key='time'><td ><b>Expiry Date</b></td><td>{dateExpiryString}{subtitleBreak}{subtitle}{subtitleBreak}{addTimePart}</td></tr>]
//

  var details2;
  if (!statsInfo){
  }else{


    var periods = ['Last Day', 'Last 30 Days', 'All Time'];

    details2 = periods.map((aPeriod, index)=>{
      var amt = 0;
      if (statsInfo.v[index].t === 'number'){
        amt = statsInfo.v[index].v
      }
      return <div className="col-4 mx-auto text-center">
          <p className="lead mb-0"><b>{aPeriod}</b></p>  
          <p className="lead mb-0">{amt} views</p>
        </div> 
    })
            
  }
//

  var codeBit;
  if (launchedCode){
    if (isDoingSomething && isDoingSomething.t === 'updatingDapp'){
    }else{
      codeBit = <iframe title='Preview' src={'https://www.cues.sg/dapps/'+currentUrl} style={{width:'100%', height:height/2, overflowY:'scroll', border:'2px solid black'}}></iframe>      
    }

//      
  }
  

  // var clickFn = clickSelect(['de', 'code'])
  // if (canCode){
  // }else{
  //   clickFn = function(e){
  //     window.alert('Code is not currently available for your dapp because of the database write call. If you are interested in generating code for such a dapp, please let us know via the feedback function and we will prioritise this development. Thank you.')
  //   }
  // }

  return <div>
          <div className="container-fluid py-5">
            <div className="row mb-4">
              <div className='col-12'>
                <div style={{float:'right'}}>
                  <NormalBtn key='0' onClick={clickBack} title='Back'/>
                </div></div>
            </div>

            <div className="row mb-4">
              <div className="col-6 mx-auto text-center">
                <h2>{header}</h2>
                <div>dApp last updated {dateUpdatedString}</div>
                <NormalBtn key='0' onClick={clickUpdate} title='Update'/>
                <br/><br/>
                {codeBit}
              </div>

              <div className="col-6 mx-auto text-center">
                <TableWrapRowsBoot rows={first.concat(infoRows).concat([ownDomainRow])} />
                <div className="row" >
                  {details2}
                  </div>
                <ClientDatabase programSetID={programSetID} userID={userID} color='#CCCCFF' signKey={signKey} sessionID={sessionID} showIfNothing={false}/>
              </div>
            </div>
          </div>
        </div>
//

}


export default App;
